import { Modal, Button, Col, Row, Input, Tabs, message, Form } from "antd";
import React, { useState } from "react";
import DbConnections from "../database/DbConnections";
import { addVariables } from "../../../service/admin.service";
import FolderPathNew from "../folderpath/FolderPathNew";
import { addDBConnection } from "../../../service/db.service";
import { validateDuplicateFolderDisplayNames } from "../../../helper/validation_helper";
import { getCurrentDateTimeInFormat } from "../../../helper/date_helper";

function EnvironmentModal({
  envName,
  environmentList,
  updateEnvironmentList,
  isOpen,
  openModal,
}) {
  let name = envName;
  const [environmentName, setEnvironmentName] = useState(name);
  const [folderData, setFolderData] = useState([]);
  const [dbDataSource, setDbDataSource] = useState([]);

  const handleModal = () => {
    showWarning();
  };
  const showWarning = () => {
    Modal.confirm({
      title: "You will lose all the changes if you cancel",
      content: "Are you sure you want to cancel?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        closeModal();
      },
      onCancel() {
        openModal(true);
      },
    });
  };

  const closeModal = () => {
    openModal(false);
    setEnvironmentName("");
  };

  const onClickSave = () => {
    if (!environmentName || environmentName.trim() === "") {
      message.error("Environment name cannot be empty!");
      return;
    }
    if (folderData.length === 0 && dbDataSource.length === 0) {
      message.warning("Please configure Folder Path or Database connection!");
      return;
    }
    const invalidFolder = folderData.find(
      (folder) =>
        (folder.description && folder.comment.trim() === "") ||
        (folder.comment && folder.description.trim() === ""),
    );
    if (invalidFolder) {
      message.error("Folder Path or Display cannot be empty!");
      return;
    }
    if (folderData.length === 0) {
      message.warning("No Folder path configured!");
      return;
    }
    if (dbDataSource.length === 0) {
      message.warning("No Database connection configured!");
      return;
    }
    const folderNameError = validateDuplicateFolderDisplayNames(folderData);
    if (folderNameError) {
      message.error(folderNameError);
      return;
    }

    const createdNow = getCurrentDateTimeInFormat();
    const saves = [];

    if (folderData.length > 0) {
      const stampedFolders = folderData.map((f) => ({
        ...f,
        createdDate: createdNow,
      }));
      saves.push(
        addVariables(stampedFolders).then((res) => {
          if (res.status !== 200) throw new Error("Something went wrong!");
          return "Folder Path Saved!";
        }),
      );
    }

    if (dbDataSource.length > 0) {
      const stampedDbConnections = dbDataSource.map((d) => ({
        ...d,
        createDate: createdNow,
      }));
      saves.push(
        addDBConnection(environmentName, stampedDbConnections).then(
          () => "Database Connection Saved!",
        ),
      );
    }

    Promise.all(saves)
      .then((messages) => {
        updateEnvironmentList();
        messages.forEach((m) => message.success(m));
        closeModal();
      })
      .catch((error) => {
        message.error(error?.message || "Something went wrong!");
      });
  };

  const environmentNamePresent = environmentList.some(
    (item) =>
      item.displayName.toLowerCase() === environmentName?.toLocaleLowerCase(),
  );
  const onChangeEnvironmentName = (e) => {
    setEnvironmentName(e.target.value);
  };
  const onFolderUpdate = (data) => {
    console.log(data);
    setFolderData(data);
  };
  const updateDbData = (data) => {
    setDbDataSource(data);
    console.log(data);
  };
  const newSteps = [
    {
      label: "Folder Path",
      key: 1,
      children: (
        <FolderPathNew
          environmentName={environmentName}
          onFolderUpdate={onFolderUpdate}
        />
      ),
    },
    {
      label: "Database Connections",
      key: 2,
      children: <DbConnections updateDbDataSource={updateDbData} />,
    },
  ];

  return (
    <div>
      <Modal
        open={isOpen}
        destroyOnClose
        maskClosable={false}
        centered
        width="150vh"
        footer={[
          <Button key="back" onClick={onClickSave}>
            Save
          </Button>,
          <Button key="submit" type="primary" onClick={handleModal}>
            Cancel
          </Button>,
        ]}
        onCancel={handleModal}
      >
        <Row style={{ paddingBottom: "20px" }}>
          <p className="modal-header-text">Create New Environment</p>
        </Row>
        <Row></Row>
        <Row>
          <Col span={6}>
            <p className="spec-modal-label">Environment Name * </p>
            <p>{envName}</p>
          </Col>
          <Col span={18}>
            <Form layout="vertical">
              <Form.Item
                validateStatus={environmentNamePresent ? "error" : ""}
                help={
                  environmentNamePresent
                    ? "Please choose a different environment name"
                    : ""
                }
              >
                <Input
                  placeholder="environment name"
                  value={environmentName}
                  onChange={onChangeEnvironmentName}
                  style={{
                    borderColor: environmentNamePresent ? "red" : undefined,
                    boxShadow: environmentNamePresent
                      ? "0 0 0 2px rgba(255, 0, 0, 0.2)"
                      : undefined,
                  }}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>

        <Tabs defaultActiveKey="1" type="card" size="small" items={newSteps} />
      </Modal>
    </div>
  );
}

export default EnvironmentModal;
